import { ImagesApp } from '../../../../constants/images';
import { useI18nContext } from '../../../../hooks/contexts/i18n.context';
import { DEFAULT_LOCALE, normalizeLocale } from '../../../../i18n/locale';
import { LOCALE_BADGES } from '../../../../i18n/localeLabels';
import * as Style from './styles.localeSelect';

const SelectedLocale = () => {
  const { currentLocale } = useI18nContext();

  /*
   * Derived straight from the context, with no state and no effect.
   *
   * This used to keep two `useState`s synchronised in a `useEffect`, seeded
   * with a Brazilian flag and the label "PT" — inconsistent with each other on
   * the very first paint. It also reached the flag map through
   * `SafeLanguages[tag.replace('-','_')]`, which returned `undefined` for any
   * locale outside the three and rendered a broken image.
   */
  const locale = normalizeLocale(currentLocale.locale) ?? DEFAULT_LOCALE;

  return (
    <Style.StyledSelectedLocale id="selected-locale-container">
      <Style.StyledBadgeLocale
        id="badge-locale-selected"
        src={ImagesApp.countries[locale]} />
      <Style.StyledTextMenu id="text-menu-locale-selected">
        {LOCALE_BADGES[locale]}
      </Style.StyledTextMenu>
    </Style.StyledSelectedLocale>
  );
};

export default SelectedLocale;
